import { render, staticRenderFns } from "./uploadNew2.vue?vue&type=template&id=e66c329e&scoped=true&"
import script from "./uploadNew2.vue?vue&type=script&lang=js&"
export * from "./uploadNew2.vue?vue&type=script&lang=js&"
import style0 from "./uploadNew2.vue?vue&type=style&index=0&id=e66c329e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66c329e",
  null
  
)

export default component.exports